import { render, staticRenderFns } from "./IvFormSidebar.vue?vue&type=template&id=1859c719"
import script from "./IvFormSidebar.vue?vue&type=script&lang=js"
export * from "./IvFormSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports